module.exports = __webpack_public_path__ + "static/media/search-btn.5cb4ef2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/search-btn.svg
// module id = 222
// module chunks = 0